import React, { useState, useEffect } from "react";
import { Card,CardBody,CardHeader, Container,FormGroup ,Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,Col,Row,Badge } from "reactstrap";
import { useForm} from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import {QuillEditor,FormInput, SingleAutocompleteGrouping,FormRadio,FormAutocomplete,FormAutocompleteGrouping, FormAutocompleteGroupingRegion, AddFieldWithPopUpAutocomplete,FormCheckBox} from "_components/FormElements/FormInput";
import MediaLibrary from "views/Hoc/Dialog/MediaLibrary";
import {BrandCard,ProfileCard} from "views/Hoc/BrandCard";
import { history } from '../../../../_helpers';
import { dashboardActions } from '../../../../_actions';
import { TradeInformationSchema } from '../validation';
import AddBrand from "views/Hoc/Dialog/AddBrand";
import AddKeyPartner from "views/Hoc/Dialog/AddKeyPartner";
import {useBeforeFirstRender} from '_hooks/index'
import axios from 'axios';
import ImageLibrary from 'views/Hoc/Dialog/ImageLibrary';
import {ModalSpinner} from 'views/Hoc/Spinner';
import { Spinner} from 'views/Hoc/Spinner';
import {InputLabel,Select,TextField,FormControl,InputAdornment,FormHelperText} from '@material-ui/core';
import {ToastsContainer, ToastsStore} from 'react-toasts';
import { commonService } from '_services/common.service';
var _ = require('lodash');

const TradeInformation = (props) => {
  
  let maturitylevel=false;
  const [opneadd, opneAddnew] = useState(false);
  const [openDist, setOpenDist] = useState(false);
  const [openRetailer, setOpenRetailer] = useState(false);
  const [brandName, setBrandName] = useState('');
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, control, errors, watch,formState } = useForm({      
    mode:'onBlur',  
    resolver: yupResolver(TradeInformationSchema),
  });
  
  //localStorage
  var userData = JSON.parse(localStorage.getItem('CHuser'));
  let typeId=userData?.channelTypeId;

  const [state, setState] = useState({
    profile: '',
    areYouStartUp : '0',
    no_of_staffs : '',
    startUpType: '',
    sales : null,    
    marketing : null,
    technical : null,
    purchase : null,
    domesticRevenue : null,
    internationalRev : null,
    frenchTech : 'No',
    annualTurnOver : '',
    productBrand : [],
    brand : [],
    brandList:[],
    brandOption : [],
    productGroup:[],
    productValue : [{childid: "4",childname: "AV accessories", groupid: "1", groupname: "AV", status: true}],
    productFamilies : [],
    DistributorProfileOption:[],
    DistributorProfileValue: [],
    Distributor: [],
    DistributorList: [],
    RetailerProfileOption:[],
    Retailer: [],
    RetailerList: [],
    ChannelProfileValue : [{childid: "3",childname: "broadliner",status:true}],
    ChannelProfileOption : [],
    listOfServicesOption : [],
    listOfServiceValue : [],
    groupCount:0,
    no_of_skus : null,
    storeCount:null,
    no_of_distributors: null,
    no_of_retailers: null,
    distributorDesc: '',
    RetailerDesc: '',
    startUpType1: false,
    startUpType2: false,
    startUpType3: false,
    profileTypeId: '',
    RetailerOptions: [],
    DistributorOptions: [],
    testRetailerList: [],
    testDistributorList: [],
    deletedRetailer: [],
    deletedDistributor: [],
    speciality: [],
    specialityOptions: [],
    countryList: [],

    brandListUser: [], //dont worry about it. it's dummy but dont remove it.
    RetailerListUser: [],
    DistributorListUser: [],

    sellingCountries : [],
    sellingCountriesOption : [],
    targetCountries : [],
    targetCountriesOption : [],
    locationType:(typeId == 2 || typeId == 3) ? 'Target Locations' : 'Selling Locations',
    title: (typeId == 2 || typeId == 3) ? 'TARGET' : 'SELLING',
    sellingZones: [],
    EMEA: false,
    APAC: false,
    AMERICAS:false,
    EMEA1: false,
    APAC1: false,
    AMERICAS1:false

  })

  const [fl, setFl] = useState(false);

    
    
  //maturity level single or multiple decision making code
  
  if(typeId==3||typeId==4)
    maturitylevel=true;

  useEffect(() => {
    (async() => {
      setLoading(true);
      await getTradeLoc();
      setTimeout(1000);
      await getTradeInfo();
      setLoading(false);
    })();
    
  }, []);

  const getTradeInfo=async()=>{
      // setLoading(true);
      const countryUrl = '/common/getSignup/'+userData.channelTypeId;
      await axios.get(countryUrl).then(res =>{  
        //console.log("profiledata:",res.data);          
        state.countryList=res.data.country;
        setState({...state});
      });

      await axios.get('setting/getInitialProfile').then(res =>{      
        state.productFamilies=res.data.productGroup;

        state.company_regid=res.data.country[0].registrationcertificate;
        state.isVat=res.data.country[0].isVat;
        if(userData?.channelTypeId==2)
          state.ChannelProfileOption=res.data.profileList;
        if(userData?.channelTypeId==4 || userData?.channelTypeId==3)
        {
        let key=['Retailer'];
        state.ChannelProfileOption = res.data.profileList.filter( i => key.includes( i.groupname ) );
        }
        if(userData?.channelTypeId==3)
        {
          let key=['Distributor'];
          state.DistributorProfileOption = res.data.profileList.filter( i => key.includes( i.groupname ) );
        }
          
    
        state.brandOption=res.data.productBrand;
        state.brandOption.push({name: 'Add Brand', id: 0, doc_id: '0', documentpath: process.env.REACT_APP_DEFALTIMAGE1+'document/company/logo/zF71l5KG_1548153498529_1548153484685.jpg'})
        setState({...state, brandOption:state.brandOption});
        setState({...state, productFamilies:state.productFamilies});
        setState({...state, ChannelProfileOption:state.ChannelProfileOption});
        setState({...state, DistributorProfileOption:state.DistributorProfileOption});
        setState({...state, company_regid:state.company_regid});
        setState({...state, isVat:state.isVat});
        
        
      }).catch(err => {        
        //ToastsStore.error('Company Not Found!')
        commonService.postService({err:JSON.stringify(err),reqUrl:window.location.pathname,service:'setting/getInitialProfile'},'/error')
      });   

      const apiUrl = '/setting/tradeinfo';
      await axios.get(apiUrl).then(res =>{  
        //console.log("profiledata:",res.data);          
        //state.countryList=res.data.country;
        if(maturitylevel && res.data.maturitylevel)
          {
            res.data.maturitylevel.map(x => {
              if(x == 'PROTOTYPE') state.startUpType1 = true;
              if(x == 'S_BACKER') state.startUpType2 = true;
              if(x == 'S_VOLUME') state.startUpType3 = true;
              state.startUpType = 'set';
            })
          }else{
            if(res.data.maturitylevel)
              state.startUpType=res.data.maturitylevel[0];
          }

          state.DistributorOptions = res.data.keyPartners.keyDistributorOptions;
          state.RetailerOptions = res.data.keyPartners.keyRetailerOptions;
          state.DistributorList = res.data.channelKeyDistributor;
          state.RetailerList = res.data.channelKeyRetailer;
          state.listOfServicesOption = res.data.serviceListOptions;
          state.listOfServiceValue = res.data.serviceListValues;
          state.testRetailerList = res.data.channelKeyRetailer.map(x => x.id);
          state.testDistributorList = res.data.channelKeyDistributor.map(x => x.id);
          state.specialityOptions = res.data.specialityOptions.map(x => ({id: x.productGroupId, name: x.productGroup}));
          state.speciality = res.data.channelSpeciality.map(x => ({id: x.productGroup.id, name: x.productGroup.name}));

          if(res.data.profileType.length){
            state.DistributorProfileValue = Object.assign(res.data.profileType[0], {firstLetter: res.data.profileType[0].groupname});
            state.DistributorProfileOption = state.DistributorProfileOption.map(x => {
              if(x.childid == state.DistributorProfileValue.childid)
                return {...x, status: true}
              else
                return x;
            })
          }

          if(res.data.product.length && state.productFamilies.length){
            state.productFamilies = state.productFamilies.map(x => {
              res.data.product.map(y => {
                if(x.groupid == y.groupid && x.childid == y.childid){
                  x.status = true;
                }
              })
              return x;
            })
          }

//brandList:res.data.brand,productValue:res.data.product,storeCount:res.data.storeCount,no_of_skus:res.data.no_of_skus,no_of_staffs:res.data.empCnt.replace(/\s/g, "").trim(),annualTurnOver:res.data.turnoverRange.replace(/\s/g, "").trim(),
//sales: res.data.sales?+res.data.sales:'', marketing: res.data.marketing?+res.data.marketing:'', technical: res.data.technical?+res.data.technical:'',
//purchase: res.data.purchase?+res.data.purchase:'',domesticRevenue:typeId=='4'?res.data.turnoverOnStore:res.data.revD,internationalRev:typeId=='4'?res.data.onlineStore:res.data.revI,
          setState({...state,ChannelProfileValue:(userData.channelTypeId=='4'||userData.channelTypeId=='5')?res.data.profile[0]:res.data.profile,
            areYouStartUp:res.data.startup,
            no_of_distributors:res.data.no_of_distributors,
            no_of_retailers:res.data.no_of_retailers,startUpType1:state.startUpType1,startUpType2:state.startUpType2,startUpType3:state.startUpType3,startUpType:state.startUpType,
            profileTypeId: +res.data.profileTypeId, distributorDesc: res.data.keydistributors, RetailerDesc: res.data.keyretailers,
            frenchTech: res.data.isFrenchTech == '1' ? 'Yes' : 'No',productFamilies: state.productFamilies,
          });
          console.log('tradestate',state);
          // getTradeLoc();
          // setLoading(false);
        
        
      }).catch(err => {
        //ToastsStore.error('Company Not Found!')
        commonService.postService({err:JSON.stringify(err),reqUrl:window.location.pathname,service:'/setting/tradeinfo'},'/error')
      });
      
  }

  const getTradeLoc = async() => {
    
    await axios.get('setting/getUserProfile/'+userData?.channelId).then(res =>{    
          
      state.targetCountriesOption=res.data.regions;
      state.sellingCountriesOption=res.data.regions1;
      
      setState({...state, targetCountriesOption:state.targetCountriesOption, sellingCountriesOption:state.sellingCountriesOption});          
      console.log("pro:",res);
    }).catch(err => {        
     // ToastsStore.error('Location Not Found!')
      commonService.postService({err:JSON.stringify(err),reqUrl:window.location.pathname,service:'setting/getUserProfile'},'/error')
    });
  
    let apiUrl1 = '/setting/tradelocation';
  
    await axios.get(apiUrl1).then(res =>{            
      console.log("profiledata:",res.data);  

      if(res.data.targetLocation.length && state.targetCountriesOption){
        state.targetCountriesOption = state.targetCountriesOption.map(x => {
          res.data.targetLocation.map(y => {
            if(x.groupid == y.groupid && x.childId == y.childId)
              x.status = true;
          })
          return x;
        })
      }

      if(res.data.sellingLocation.length && state.sellingCountriesOption){
        state.sellingCountriesOption = state.sellingCountriesOption.map(x => {
          res.data.sellingLocation.map(y => {
            if(x.groupid == y.groupid && x.childId == y.childId)
              x.status = true;
          })
          return x;
        })
      }

      res.data.zone.tzone.map(x => {
        if(x.zoneId==='1')
            state.EMEA=true;
        if(x.zoneId==='3')
            state.APAC=true;
        if(x.zoneId==='2')
            state.AMERICAS=true;
      })

      
      res.data.zone.szone.map(x => {
        if(x.zoneId==='1')
            state.EMEA1=true;
        if(x.zoneId==='3')
            state.APAC1=true;
        if(x.zoneId==='2')
            state.AMERICAS1=true;
      })
      
      state.targetCountries = res.data.targetLocation;
      state.sellingCountries = res.data.sellingLocation;
      setState({...state, targetCountries:res.data.targetLocation,sellingCountries:res.data.sellingLocation,sellingZones:res.data.zone, sellingCountriesOption: state.sellingCountriesOption, targetCountriesOption: state.targetCountriesOption});
      // setLoading(false);
      console.log('tradeLoc', state);
      setFl(true);
    }).catch(err => {        
      //ToastsStore.error('Location Not Found!')
      commonService.postService({err:JSON.stringify(err),reqUrl:window.location.pathname,service:'setting/tradelocation'},'/error')
    });     


  }

  useEffect(() => {
    if(fl)
    getSearchRegion();
  }, [state.EMEA, state.AMERICAS, state.APAC, state.EMEA1, state.AMERICAS1, state.APAC1]);

  const getSearchRegion = async() => {
    let zone = [];
    if(state.title == 'TARGET')
    {
      if(state.EMEA) zone.push(1);
      if(state.AMERICAS) zone.push(2);
      if(state.APAC) zone.push(3);
    }
    else{
      if(state.EMEA1) zone.push(1);
      if(state.AMERICAS1) zone.push(2);
      if(state.APAC1) zone.push(3);
    }        
    
    if(zone.length){
      let res = await axios.post('/setting/searchRegion', {exclude: true,
        locationType: state.title, zone: zone, region: ''}).then(res => {
        if(state.title == 'TARGET'){
          state.targetCountriesOption = res.data;

          let temp = [];
          if(state.targetCountries.length){
            temp = state.targetCountries.filter(el => state.targetCountriesOption.find(({groupid}) => groupid==el.groupid));
            state.targetCountriesOption = state.targetCountriesOption.map(x => {
              temp.map(y => {
                if(x.groupid==y.groupid && x.childId==y.childId)
                  x.status = true;
              })
              return x;
            })
            state.targetCountries=temp;
          }

        }else if(state.title == 'SELLING'){
          state.sellingCountriesOption = res.data;

          let temp = [];
          if(state.sellingCountries.length){
            temp = state.sellingCountries.filter(el => state.sellingCountriesOption.find(({groupid}) => groupid==el.groupid));
            state.sellingCountriesOption = state.sellingCountriesOption.map(x => {
              temp.map(y => {
                if(x.groupid==y.groupid && x.childId==y.childId)
                  x.status = true;
              })
              return x;
            })
            state.sellingCountries=temp;
          }
        }
        setState({...state});
        }).catch(err => {        
          //ToastsStore.error('Region Not Found!')
          commonService.postService({err:JSON.stringify(err),reqUrl:window.location.pathname,service:'setting/searchRegion'},'/error')
        });
    }
    else{
      if(state.title == 'TARGET'){
        state.targetCountries = [];
        state.targetCountriesOption = [];
      }else if(state.title == 'SELLING'){
        state.sellingCountries = [];
        state.sellingCountriesOption = [];
      }
      setState({...state});
    }
    }

  useEffect(() => {  
    if(!_.isEmpty(errors)&&formState.isSubmitted)
    {
      ToastsStore.error(JSON.stringify(errors));
      commonService.postService({err:JSON.stringify(errors),reqUrl:window.location.pathname,service:'validation_err'},'/error')    
    }
  }, [errors])
  
  

  const  isEqual = (a, b) =>
{ 
 
  // if length is not equal 
  if(a.length!=b.length) 
   return false; 
  else
  { 
  // comapring each element of array 
   for(var i=0;i<a.length;i++) 
   if(a[i]!=b[i]) 
    return false; 
    return true; 
  } 
} 



  const deleteBrand = (id) =>{    
    const filteredList = state.brandList.filter((item) => item.id !== id);    
    state.brandList=filteredList;
    setState({...state, brandList:state.brandList});
   if(state.brandList.length==0)
    {
      setState({...state, brandValue: []});
      errors.Brands={message: 'Please select a Brand', type:'required'};  
    }
  }

  const deleteBrand1 = (id) =>{    
    const filteredList = state.DistributorList.filter((item) => {
    
     if(item.id == id && item.keypartnerid){
       let temp = state.deletedDistributor;
       temp.push(+item.keypartnerid);
       setState({...state, deletedDistributor: temp});
     }
     if(item.id == id && item.isNew == '1'){
       state.DistributorListUser = state.DistributorListUser.filter(x => x.id != item.id)
     }
     return item.id !== id
    });    
    state.DistributorList=filteredList;
    
    setState({...state, DistributorList:state.DistributorList, DistributorListUser:state.DistributorListUser});
   if(state.DistributorList.length==0)
    {
      setState({...state, Distributor: []});
      // errors.Distributor={message: 'Please select Distributor', type:'required'};  
    }
  }

  const deleteBrand2 = (id) =>{    
    const filteredList = state.RetailerList.filter((item) => {
      if(item.id == id && item.keypartnerid)
        {
          let temp = state.deletedRetailer;
          temp.push(+item.keypartnerid);
          setState({...state, deletedRetailer: temp});
        }
        if(item.id == id && item.isNew == '1'){
          state.RetailerListUser = state.RetailerListUser.filter(x => x.id != item.id );
        }
      return item.id !== id
    });    
    state.RetailerList=filteredList;
    setState({...state, RetailerList:state.RetailerList, RetailerListUser:state.RetailerListUser});
   if(state.RetailerList.length==0)
    {
      setState({...state, Retailer: []});
      // errors.Retailers={message: 'Please select a Brand', type:'required'};  
    }
  }


//   useBeforeFirstRender(() => {
//     (async() =>{  
 
//     })();
    
// })

const selectedItem=(gname,check,optionName,optionValue) => {    
  let opt=[];    
  console.log("check:",check,gname);
  if(check==true)
  {    
    state[optionName].map((item) => {      

          if(item.groupname==gname||item.status==true)
          {
            item.status=check;      
            opt.push(item);
          }     
    });
  }
  if(check==false)
  {  
    console.log("check:",check);
    state[optionName].map((item) => {      
        if(item.groupname==gname&&state[optionValue].length>0)
            item.status=check;                          
        // if(state.productValue.length==0)
        //     item.status=false;
    });

    opt=state[optionValue].filter((item) => item.groupname!=gname);      
    opt.map(option => option.status=true);
  }
  
  state[optionValue]=opt;
  setState({...state, [optionValue]:state[optionValue]});    
  setState({...state, [optionName]:state[optionName]});    

  if(optionValue='ChannelProfileValue' && state.ChannelProfileValue.length==0)
        errors.relevantChannelProfiles=true;
  else if(optionValue='productValue' && state.productValue.length==0)
        errors.productCat=true;
}
  
  const watchAll = watch(['no_of_retailers','no_of_distributors','no_of_skus','storeCount' ]);
  //console.log('watchall', watchAll);


  

  const save = async() => {
    try{    
    setLoading(true);
    let mLevel=[];
    let listOfServices= [];
    if(typeId=='2' && state.areYouStartUp === '1'){
      mLevel.push(state.startUpType);
    }      
    else if((typeId=='3' || typeId=='4') && state.areYouStartUp == '1')
      { 
        if(state.startUpType1) mLevel.push(startUp[0].value);
        if(state.startUpType2) mLevel.push(startUp[1].value);
        if(state.startUpType3) mLevel.push(startUp[2].value);
        // listOfServices = state.listOfServiceValue.map(x => ({id: +x.id}));
      }
      console.log('maturity',mLevel);

      // let productFamilies = [];
      // let uniq = _.uniq(state.productValue.map(x => +x.groupid));
      // uniq.map(x => {
      //   productFamilies.push({id: +x});
      // })
      // let productCategories = [];
      // state.productValue.map(x => {
      //   productCategories.push({
      //     productFamilId: +x.groupid,
      //     productCategoriesId: +x.childid
      //   })
      // })
      
      //for key distributor
      let keyDistributors = [];

      if(isEqual(state.DistributorList.map(x=>x.id).sort(), state.testDistributorList.sort())){
        console.log('no change');
      }else{
        state.DistributorList.map(x => {
          let temp = {};
          if(x.active){
            temp.keypartnerid = x.keypartnerid;   
            temp.partnername = x.name;
            temp.existchannelid = x.id;
            temp.countryid = x.active.country.country_id;
            temp.image = x.documentPath ? x.documentPath : null;
            temp.imageid = x.documentPath ? x.active.logo.logo_id : null;
          }else if(x.old){
            temp.keypartnerid = x.keypartnerid;   
            temp.partnername = x.name;
            temp.oldchannelid = x.id;
            temp.countryid = x.old.country.country_id;
            temp.image = x.documentPath ? x.documentPath : null;
            temp.imageid = x.documentPath ? x.old.logo.logo_id : null;
          }
          else if(x.new){
            temp.keypartnerid = x.keypartnerid;   
            temp.partnername = x.name;
            temp.countryid = x.new.country.country_id;
            temp.image = x.documentPath ? x.documentPath : null;
            temp.imageid = x.documentPath ? x.new.logo.logo_id : null;
          }
          else if(x.isNew!='1'){
            if(x.oldchannelid)
              temp.oldchannelid = x.oldchannelid;
            else if(x.channelId)
              temp.existchannelid = x.channelId;
            
            temp.partnername = x.companyName;
            temp.image = x.companylogo ? x.companylogo.documentPath : null;
            temp.imageid = x.companylogo ? x.companylogo.documentId : null;
            temp.countryid = x?.regaddresscountry?.countryId;
            
          }
          if(x.isNew == '1')
            {
              
              if(x.documentpath)
                temp.image = x.documentpath;
              
              temp.partnername = x.name;
              temp.countryid = +x.countryId;
            }
          keyDistributors.push(temp);
        })
        //console.log('fasle');
      }

      //for key retailer

      let keyRetailer = [];

      if(isEqual(state.RetailerList.map(x=>x.id).sort(), state.testRetailerList.sort())){
        console.log('no change');
      }else{
        state.RetailerList.map(x => {
          let temp = {};
          if(x.active){
            temp.keypartnerid = x.keypartnerid;   
            temp.partnername = x.name;
            temp.existchannelid = x.id;
            temp.countryid = x.active.country.country_id;
            temp.image = x.documentPath ? x.documentPath : null;
            temp.imageid = x.documentPath ? x.active.logo.logo_id : null;
          }else if(x.old){
            temp.keypartnerid = x.keypartnerid;   
            temp.partnername = x.name;
            temp.oldchannelid = x.id;
            temp.countryid = x.old.country.country_id;
            temp.image = x.documentPath ? x.documentPath : null;
            temp.imageid = x.documentPath ? x.old.logo.logo_id : null;
          }
          else if(x.new){
            temp.keypartnerid = x.keypartnerid;   
            temp.partnername = x.name;
            temp.countryid = x.new.country.country_id;
            temp.image = x.documentPath ? x.documentPath : null;
            temp.imageid = x.documentPath ? x.new.logo.logo_id : null;
          }else if(x.isNew!='1'){
            if(x.oldchannelid)
              temp.oldchannelid = x.oldchannelid;
            else if(x.channelId)
              temp.existchannelid = x.channelId;
            
            temp.partnername = x.companyName;
            temp.image = x.companylogo ? x.companylogo.documentPath : null;
            temp.imageid = x.companylogo ? x.companylogo.documentId : null;
            temp.countryid = x?.regaddresscountry?.countryId;
            
          }if(x.isNew == '1')
          {
            // temp.countryid = x.countryId;
            if(x.documentpath)
              temp.image = x.documentpath;
            
            temp.partnername = x.name;
            temp.countryid = +x.countryId;
          }
          
          keyRetailer.push(temp);
        })
        console.log('fasle');
      }

      // let specialityValue = state.speciality.map(x => ({specialityId: +x.id}));

      let data = {};
      if(typeId == '2'){
        data = {
          keydistributors : state.distributorDesc,
          keyretailers : state.RetailerDesc,
          profileTypeId : +state.profileTypeId,
          // brand : [].concat(state.brandList.map(x => ({id: +x.id, name: x.name, documentPath: x.documentpath, isNew: x.isNew}))),
          // no_of_skus : +watchAll.no_of_skus,
          // domesticSales: state.sales?+state.sales:null,
          // internationalSales: state.marketing?+state.marketing:null,
          // domesticMarketing: state.technical?+state.technical:null,
          // internationalMarketing: state.purchase?+state.purchase:null,
          startup : state.areYouStartUp,
          maturitylevel : state.areYouStartUp=="1"?mLevel:[],        
          // domesticRevenue: state.domesticRevenue?+state.domesticRevenue:null,
          // internationalRevenue: state.internationalRev?+state.internationalRev:null,
          no_of_distributors: watchAll.no_of_distributors?+watchAll.no_of_distributors:state.no_of_distributors,
          no_of_retailers: watchAll.no_of_retailers?+watchAll.no_of_retailers:state.no_of_retailers,
        }  
      }else if(typeId == '3'){
        data = {
          profileTypeId : +state.DistributorProfileValue.childid,
          keyretailers : state.RetailerDesc,
          // brand : [].concat(state.brandList.map(x => ({id: +x.id, name: x.name, documentPath: x.documentpath, isNew: x.isNew}))),
          // listOfServices : [].concat(state.listOfServiceValue.map(x => ({id: +x.id}))),
          // domesticSales: state.sales?+state.sales:null,
          // internationalSales: state.marketing?+state.marketing:null,
          // domesticMarketing: state.technical?+state.technical:null,
          // internationalMarketing: state.purchase?+state.purchase:null,
          startup : state.areYouStartUp,
          maturitylevel : state.areYouStartUp=="1"?mLevel:[],        
          // domesticRevenue: state.domesticRevenue?+state.domesticRevenue:null,
          // internationalRevenue: state.internationalRev?+state.internationalRev:null,
          no_of_retailers: watchAll.no_of_retailers?+watchAll.no_of_retailers:0,
          // ...listOfServices.length && {listOfServices: listOfServices} ,
          // ...specialityValue && {distributorSpeciality : specialityValue},
        }  
      }else if(typeId == '4' || typeId == '4'){
        data = {
          profileTypeId: +state.ChannelProfileValue.childid,
          // physicalStore: state.domesticRevenue?+state.domesticRevenue:null,
          // OnlineStore:  state.internationalRev?+state.internationalRev:null,
          // storeCount: +state.storeCount,
          startup:  state.areYouStartUp,
          maturitylevel : state.areYouStartUp=="1"?mLevel:[],        
        }
      }

      //deleted retailer
      if(state.deletedRetailer.length){
        if(state.RetailerList.length){
          state.RetailerList.map(x => {
            if(x.keypartnerid)
              {
                let temp = state.deletedRetailer.filter(id => x.keypartnerid != id)
                setState({...state, deletedRetailer: temp});
              }
          })
        }
      }

      //deleted distributor
      if(state.deletedDistributor.length){
        if(state.DistributorList.length){
          state.DistributorList.map(x => {
            if(x.keypartnerid)
              {
                let temp = state.deletedDistributor.filter(id => x.keypartnerid != id)
                setState({...state, deletedDistributor: temp});
              }
          })
        }
      }

      //key retailer value
      if(keyRetailer.length){
        data = Object.assign(data, {channelKeyRetailer : keyRetailer})
      }

      //key distributor value
      if(keyDistributors.length){
        data = Object.assign(data, { channelKeyDistributor : keyDistributors })
      }

      //delete retailer value
      if(state.deletedRetailer.length){
        data = Object.assign(data, {deletedkeyretailer: state.deletedRetailer})
      }

      //delete distributor value
      if(state.deletedDistributor.length){
        data = Object.assign(data, {deletedkeydistributor: state.deletedDistributor});
      }

      //for vendor
      if(typeId=='2' && state.areYouStartUp=='1' && state.startUpType=='S_VOLUME'){
        
      }
      
      if(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(state.no_of_staffs))
        data['employeesRange'] = state.no_of_staffs
      else
        data['employeesCount'] = +state.no_of_staffs

      if(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(state.annualTurnOver))
        data['annualTurnoverRange'] = state.annualTurnOver
      else
        data['annualTurnover'] = +state.annualTurnOver
        
  let finalData = {
    channelType: +typeId,
    // productFamilies: productFamilies,
    // productCategories: productCategories,
    // customerProfiles: (typeId==4)?[{profileTypeId:+state.ChannelProfileValue.childid,profileTypeClassificationId:+state.ChannelProfileValue.profiletypeclassificationid}]:[].concat(state.ChannelProfileValue.map(x => {return {profileTypeId:+x.childid,profileTypeClassificationId:+x.profiletypeclassificationid} })),
    // is_french_tech: state.frenchTech=="Yes" ? '1' : '0',
  }
  
     finalData = typeId=='2' ? Object.assign(finalData, {tradeInformationVendor: data}) : typeId == '3' ?  Object.assign(finalData, {tradeInformationDistributor: data}) : Object.assign(finalData, {tradeInformationRetailer: data})

     let result=await dashboardActions.updateTradeInfo(finalData).catch(err=> {
      ToastsStore.error('Something Went Wrong!');
      commonService.postService({err:JSON.stringify(err),reqUrl:window.location.pathname,service:'/setting/updateTradeInfo'},'/error')
       setLoading(false)
     });
     //console.log('saveresuult', result);
     if(result) 
     {      
        await saveTradeLoc();
      // ToastsStore.success('Saved Successfully!');
     }

    }
    catch(err)
    {        
      ToastsStore.error('Something Went Wrong! while saving tradeInformation');
      console.log('error123', err);
      setLoading(false);    
      commonService.postService({err:JSON.stringify(err),reqUrl:window.location.pathname,service:'updateTradeInfo'},'/error');       
    }       
   
  }
  
  const handleChange = input => e => {
    console.log("add",e.target.value);  
    // setState({...state, [input] : e.target.value});
    
    if(input === 'startUpType1' || input === 'startUpType2' || input === 'startUpType3')
    {      
      state[input] = !state[input];  
      state.startUpType = state.startUpType1?'set':state.startUpType2?'set':state.startUpType3?'set':'';
      setState({...state, startUpType : state.startUpType, [input]: state[input]});  
    }
    else if(input==='locationType' && state.locationType!=e.target.value){

      // state.EMEA=false;                
      // state.APAC=false;
      // state.AMERICAS=false;

      // if(e.target.value==='Target Locations')
      // {
      //   state.sellingZones.tzone.map(x => {
      //     if(x.zone==='EMEA')
      //         state.EMEA=true;                
      //     if(x.zone==='APAC')
      //         state.APAC=true;
      //     if(x.zone==='AMERICAS')
      //         state.AMERICAS=true;
      //   })
      // }

      // if(e.target.value==='Selling Locations')
      // {
      //   state.sellingZones.szone.map(x => {
      //     if(x.zone==='EMEA')
      //         state.EMEA1=true;                
      //     if(x.zone==='APAC')
      //         state.APAC1=true;
      //     if(x.zone==='AMERICAS')
      //         state.AMERICAS1=true;
      //   })
      // }

      errors.target=false;
      errors.selling=false;
      setState({...state, [input] : e.target.value, title: e.target.value==='Target Locations' ? 'TARGET' : 'SELLING'});  
    }else if(input === 'AMERICAS' || input === 'EMEA' || input === 'APAC' || input === 'AMERICAS1' || input === 'EMEA1' || input === 'APAC1'){
      setState({...state, [input]: !state[input]});
    }
    else{
      setState({...state, [input] : e.target.value});
    }
    // if(input=='areYouStartUp'&&value=='0'){
    //   state.maturitylevel=null;
    //   setState({...state, maturitylevel:state.maturitylevel});
    // }
    // else    
  }

  const handleChangeSelect = (input,value) => {

   

    if(input=='productFamily'){        
      state.productFamilies.map((item) => {      
        if(value.length==0)
          item.status=false;
        else
        {
          // value.map(v => {          
          //   // if(v.childname!=item.childname)
          //   //   item.status=false;                 
          //    if(v.childname==item.childname)            
          //     item.status=true;                       
            
          // });      
          if(value.filter(e => e.childname == item.childname).length)
              item.status = true;
            else
              item.status = false;
        }
      });
  
      value.map(option => option.status=true);
      state.productValue= value
      setState({...state, productFamilies:state.productFamilies});
      setState({...state, productValue:state.productValue});

      // state.productValue= value
      // setState({...state, productValue:state.productValue});
      if(state.productValue.length==0)
        errors.productValue=true;

      let Group=_.uniq(state.productValue.map(x => x.groupid));
      state.groupCount=Group.length;
      setState({...state,groupCount:state.groupCount});     


      
    }
    else if(input=='relevantChannelProfile'){
      state.ChannelProfileOption.map((item) => {      
        if(value.length==0)
          item.status=false;
        else
        {
          // value.map(v => {          
          //   // if(v.childname!=item.childname)
          //   //   item.status=false;                 
          //    if(v.childname==item.childname)            
          //     item.status=true;                       
            
          // });      
          if(value.filter(e => e.childname == item.childname).length)
              item.status = true;
            else
              item.status = false;
        }
      });

      value.map(option => option.status=true);
      state.ChannelProfileValue= value
      setState({...state, ChannelProfileOption:state.ChannelProfileOption});
      setState({...state, ChannelProfileValue:state.ChannelProfileValue});

      if(state.ChannelProfileValue.length==0)
        errors.relevantChannelProfiles=true;
      // state.ChannelProfileValue= value
      // setState({...state, ChannelProfileValue:state.ChannelProfileValue});
    }
    else if(input=='relevantRetailerProfile'){
      state.ChannelProfileValue= value
      setState({...state, ChannelProfileValue:state.ChannelProfileValue});
    }
    // else if(input=='listOfServiceValue'){
    //   state.listOfServiceValue= value
    //   setState({...state, listOfServiceValue:state.listOfServiceValue});
    // }   
    

    else if(input=='brand' || input=='brands' || input=='Distributor' || input=='Retailer'){
      if(input=='brands')
        input = 'brand';
      if(value.name === 'Add Brand' && value.id === 0){
        setBrandName('');
        opneAdd(true);
        return <></>;
      }
      if(value.hasOwnProperty('isNew')){
        state[input]=value;
      }else{
        value.isNew='0';
        state[input]=value;
      }
      
      setState({...state, [input]:state[input]});
      let temp = state[input];
      temp = state[input+'List'].filter(x => x.id == temp.id);
      if(temp.length){
        console.log('already entered');
      }else{
        console.log('no entry')
        if(value.isNew == '1')
          state[input+'ListUser'].push(state[input]);
        state[input+'List'].push(state[input]);
        setState({...state, [input+'List']:state[input+'List'], [input+'ListUser'] : state[input+'ListUser']});
      }
      
      console.log("brandList:",state[input+'list']);
    }
    else if(input=='sellingCountries'){
      state.sellingCountriesOption.map((item) => {      
        if(value.length==0)
          item.status=false;
        else
        {
          // value.map(v => {          
          //   // if(v.childname!=item.childname)
          //   //   item.status=false;                 
          //    if(v.childname==item.childname)            
          //     item.status=true;                       
            
          // });      
          if(value.filter(e => e.childname == item.childname).length)
              item.status = true;
            else
              item.status = false;
        }
      });
  
      value.map(option => option.status=true);
      state.sellingCountries= value
      setState({...state, sellingCountries:state.sellingCountriesOption});
      setState({...state, sellingCountries:state.sellingCountries});
  
      if(state.sellingCountries.length==0)
        errors.selling=true;
    }
    else if(input=='targetCountries'){
      state.targetCountries = state.targetCountriesOption.map((item) => {      
        if(value.length==0)
          item.status=false;
        else
        {
          // value.map(v => {          
          //   if(v.childId==item.childId)
          //   {
          //     item.status=true; 
          //   }
          //   // if(v.childId==item.childId || item.status==true)            
          //   // {
          //   //   item.status=true;                       
          //   // }
          // });  
          if(value.filter(e => e.childname == item.childname).length)
              item.status = true;
            else
              item.status = false;
        }
        })
        
      // });
      value.map(option => option.status=true);
      state.targetCountries=value
      setState({...state});//, targetCountriesOption:state.targetCountriesOption});
      // setState({...state, targetCountries:state.targetCountries});
      if(state.targetCountries.length==0)
        errors.target=true;
    }
    if(input!='productFamily'&&input!='relevantChannelProfile'&& input!='relevantRetailerProfile'&&input!='brand'&&input!='brands'&&input!="Distributor"&&input!='Retailer'&&input!='sellingCountries'&&input!='targetCountries'){
      if(input=="speciality"&&value.length<=3)      
        setState({...state, [input]:value});
      else if(input!="speciality")
        setState({...state, [input]:value});
    }
      
  }

  const saveTradeLoc = async() => {
    try
    {      
    setLoading(true);
    
  let location;let locationType;
  
    if(typeId==4)      
          location=state.sellingCountries.map(x => +x.regionCountryJCTId);
    if(typeId==2)       
          location=state.targetCountries.map(x => +x.regionCountryJCTId);
                                        
    if(typeId==3){
      if(state.title == 'TARGET')
      location=state.targetCountries.map(x => +x.regionCountryJCTId);
      if(state.title == 'SELLING')
      location=state.sellingCountries.map(x => +x.regionCountryJCTId);
    }
    
    let data={
      location:location,
      locationType:(typeId==2||typeId==3)?state.title:'RETAIL'
    }
  
    console.log('save', data);
    let result = await commonService.updateTradeLocation(
    data,'setting/updateChannelLocation').catch(err=> {
      ToastsStore.error('Something Went Wrong!');
      commonService.postService({err:JSON.stringify(err),reqUrl:window.location.pathname,service:'/setting/updateChannelLocation'},'/error')
       setLoading(false)
     });
      
    if(result) 
    {
       ToastsStore.success('Saved Successfully!');
       
       (
        async() => {
          await getTradeInfo();
          await getTradeLoc();
          setLoading(false);
        }        
      )();
      //  setLoading(false);
    }
    
  }
  catch(err)
  {        
    console.log('error123', err);
    ToastsStore.error('Something Went Wrong! while saving trade location');
    setLoading(false);    
    commonService.postService({err:JSON.stringify(err),reqUrl:window.location.pathname,service:'updateChannelLocation'},'/error');       
  }
  
    
  }

  
  const opneAdd = async(input,value) => {   
  console.log('opneadd',opneadd);
  await setBrandName(input);
  opneAddnew(true);
  }  
  const opneAdd1 = async(input,value) => {   
    console.log('opneadd',opneadd);
    await setBrandName(input);
    setOpenDist(true);
    }  
  const opneAdd2 = async(input,value) => {   
  console.log('opneadd',opneadd);
  await setBrandName(input);
  setOpenRetailer(true);
  }  
  const closeModalPopup=()=>{
    setBrandName('');
    opneAddnew(false);
    setOpenRetailer(false);
    setOpenDist(false);
  }
  
console.log('satet', state);
//console.log('watchAll', watchAll)

const onSubmit = data => {    
if (data) {        
    console.log("data:",data);
}    
}
console.log('errrors', errors);




return (
<div className="main-content">
<ToastsContainer position="top_right" autoClose={5000} store={ToastsStore}/>
{loading? <Spinner />:(

        <Container className="mt-4 col-lg-10 col-md-9 col-sm-12  " fluid>
        <form noValidate onSubmit={handleSubmit(save)}>
        {loading && <div style={{ top: '50%', left: '50%', zIndex: '1000',}}><ModalSpinner /></div>}
        <input type="text" style={{position:"absolute",left:"-10000px",top:'auto',width:'1px',height:'1px',overflow:'hidden'}} id="typeId" ref={register} name="typeId" value={typeId} control={control} />

 {/* ---------------------------Trade information information------------------------------           */}

              <Card    >                   
              {/* <CardHeader>
                 <h3 className="text-center">Facts and Figures</h3>
                  <p className="text-center">Tell us about your company legal informations</p>
                  </CardHeader> */}
                  <CardBody  >
                     
                  
            <span style={{color: '#f44336',float: 'right', fontSize:'0.75rem'}}>{!errors.startUpType || (state.areYouStartUp=='1' && state.startUpType) || state.areYouStartUp=='0' ? '' : 'Please Choose Maturity Level' }</span>
              <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-12  row ">
            <div className="form-group text-center text-sm mb-0"> 
            <h4>{typeId=='2' ? 'Are you a startup *' : 'Are you looking for start-ups?' }</h4>       
            <input type="text" style={{position:"absolute",left:"-10000px",top:'auto',width:'1px',height:'1px',overflow:'hidden'}} id="areYouStartUp" name="areYouStartUp" ref={register} value={state.areYouStartUp} /> 
            <FormRadio
                    name="startup"
                    className="text-sm mb-0"
            
                    options={radioGroupOptions}
                    control={control}
                    row
                    
                    value={state.areYouStartUp} 
                    onChange={handleChange('areYouStartUp')}
                     />
                 </div>           
            </div>

            

         {(state.areYouStartUp == '1' && (typeId == '3'|| typeId == '4')) &&  <div className="col-lg-4 col-md-6 col-sm-12">
           <h4>What type of start-up you would like to see?</h4>
                    <div className="chck">
          <FormCheckBox
                    id="Prototype"
                    type="checkbox"
                    label="Prototype"
                    label1={{textAlign:"justify"}}
                    //register={register}
                    checked={state.startUpType1}
                    onClick={handleChange('startUpType1')}
                    value={state.startUpType1}
                    /></div>
                    
                    <div className="chck">
          <FormCheckBox
                    id="Shipping to first backers"
                    type="checkbox"
                    label="Shipping to first backers"
                    label1={{textAlign:"justify"}}
                    //register={register}
                    checked={state.startUpType2}
                    onClick={handleChange('startUpType2')}
                    value={state.startUpType2}
                    /></div>

      <div className="chck">
          <FormCheckBox
                    id="Shipping in volume"
                    type="checkbox"
                    label="Shipping in volume"
                    label1={{textAlign:"justify"}}
                    //register={register}
                    checked={state.startUpType3}
                    onClick={handleChange('startUpType3')}
                    value={state.startUpType3}
                    /></div>
                      
    </div>}

    {(state.areYouStartUp == '1' && typeId=='2') && <div className="col-lg-4 col-md-6 col-sm-12">
           <h4>What's your maturity level? * </h4>

           <FormRadio
                    name="startup"
                    className="text-sm mb-0"
            
                    options={startUp}
                    control={control}
                    row
                    
                    value={state.startUpType} 
                    onChange={handleChange('startUpType')}
                     />
            </div>}
     
    </div>
    <input type="text" style={{position:"absolute",left:"-10000px",top:'auto',width:'1px',height:'1px',overflow:'hidden'}} id="startUpType" name="startUpType" ref={register} value={state.startUpType} /> 
    { ((typeId=='2' && state.areYouStartUp == '1' && state.startUpType=='S_VOLUME') || (typeId == '2' && state.areYouStartUp == '0') || (typeId == '3')) && <>
<div className="row">
<div className="col-lg-12 ">
  {/* Key Distributors */}

  {typeId == '2' && <><div className="col-lg-4 col-md-6 col-sm-12">
  <h4 >No.of Distributors </h4>
    <TextField className="comp-name mt-3" id="no_of_distributors" name="no_of_distributors" label="No. of Distributors *" type="number" variant="outlined" value={watchAll.no_of_distributors}
    error={errors.no_of_distributors}
    defaultValue={state.no_of_distributors}
    onChange={handleChange('no_of_distributors')}
    inputRef={register}
    />
    </div>
     <br/>
        
<div className="row">
<div className="col-lg-12 ">
            <h4 >Key Distributors </h4>
            <div className="form-group mt-3">        
           
            {state.DistributorList[0] && <BrandCard  name="BMW" deleteBrand={deleteBrand1} brandList={state.DistributorList}  img={process.env.REACT_APP_DEFALTIMAGE1+"document/brand/KVw8QS0n_1545236009520_1545236013342.png"}/>}

            {/* <input type="text" style={{position:"absolute",left:"-10000px",top:'auto',width:'1px',height:'1px',overflow:'hidden'}} id="DistributorList" name="DistributorList" ref={register} value={state.DistributorList[0] ? 'data' : ''} />  */}
{/* Autocomplete with image */}
<AddFieldWithPopUpAutocomplete
        limitTags={2}
        name="Distributor"
        id="Distributor"
        options={state.DistributorOptions}//{state.DistributorProfileOption}
        defaultValue={state.Distributor}
        value={state.Distributor}
        getOptionLabel={option => option.name}
        renderOption={option => (
         <>
         <div style={{display: '-webkit-inline-flex',
    padding: '1px 6px',
    width: '75px',
    margin: '10px 5px 0 0',
    float: 'left',
    border: '2px solid #e7e7e7',
    borderRadius: '5px',
    height: '38px'}}>

            <img  onError={(event)=>{axios.post('/media/errorLog', {url:event.target.src, documentTypeId:1, name:null}); event.target.setAttribute("src",process.env.REACT_APP_DEFALTIMAGE+"document/company/logo/zF71l5KG_1548153498529_1548153484685.jpg");}}  style={{maxWidth: '63px',backgroundColor: '#fff',
    maxHeight: '34px',
    height: 'auto',
    width: 'auto',
    margin: '0 auto',
    cursor: 'pointer'}} src={option.documentpath} />    </div>
          <span>
            {option.name}
          </span>
          </>
        )}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" label="Key Distributors" placeholder="Key Distributors" />
        )}
        label="Key Distributors"
        placeholder="Key Distributors"
        input="Distributor"
        control={control}
        register={register}
        // errMessage={'Please Select  Key Distributors'}
        // error={errors.Distributor&&!state.DistributorList[0]? errors.Distributor : (errors.DistributorList && !state.DistributorList[0]) ? true : false}
        handleChangeSelect={handleChangeSelect}
        opneAdd={opneAdd1}
      />
      {brandName && <AddKeyPartner aws_folderName="brandlogo" opneadd={openDist} closeModalPopup={closeModalPopup} brandName={brandName} handleChangeSelect={handleChangeSelect} partner_type={3} input="Distributor" countryList={state.countryList} userList={state.DistributorListUser} />}

                 </div>           
            </div>
</div>
<div className="row">
    <div className="col-lg-12">
    <div className="form-group">            
<form>
  <textarea 
  class="buytext2" 
  id="exampleFormControlTextarea1" 
  onChange={handleChange('distributorDesc')}
  rows="3" 
  value={state.distributorDesc}
  aria-label="empty textarea"
  placeholder="Others Key Distributors Description">
  </textarea>
</form> 
             </div>
    </div>
</div></>}

  {/* Key Retailers */}

  <div className="col-lg-4 col-md-6 col-sm-12">
  <h4 >No.of Retailers </h4>
    <TextField className="comp-name mt-3" name="no_of_retailers" id="no_of_retailers" label="No. of Retailers *" type="number" variant="outlined" value={watchAll.no_of_retailers}
    onChange={handleChange('no_of_retailers')}
    defaultValue={state.no_of_retailers}
    error={errors.no_of_retailers}
    inputRef={register}
    />
    </div>
    <br />
            <h4 >Key Retailers </h4>
            <div className="form-group mt-3">        
           
            {state.RetailerList[0] && <BrandCard  name="BMW" deleteBrand={deleteBrand2} brandList={state.RetailerList}  img={process.env.REACT_APP_DEFALTIMAGE1+"document/brand/KVw8QS0n_1545236009520_1545236013342.png"}/>}

            {/* <input type="text" style={{position:"absolute",left:"-10000px",top:'auto',width:'1px',height:'1px',overflow:'hidden'}} id="retailerList" name="retailerList" ref={register} value={state.RetailerList[0] ? 'data' : ''} />  */}
{/* Autocomplete with image */}
<AddFieldWithPopUpAutocomplete
        limitTags={2}
        name="Retailers"
        id="Retailers"
        options={state.RetailerOptions} //{state.RetailerProfileOption}
        defaultValue={state.Retailer}
        value={state.Retailer}
        getOptionLabel={option => option.name}
        renderOption={option => (
         <>
         <div style={{display: '-webkit-inline-flex',
    padding: '1px 6px',
    width: '75px',
    margin: '10px 5px 0 0',
    float: 'left',
    border: '2px solid #e7e7e7',
    borderRadius: '5px',
    height: '38px'}}>

            <img  onError={(event)=>{axios.post('/media/errorLog', {url:event.target.src, documentTypeId:1, name:null}); event.target.setAttribute("src",process.env.REACT_APP_DEFALTIMAGE+"document/company/logo/zF71l5KG_1548153498529_1548153484685.jpg");}}  style={{maxWidth: '63px',backgroundColor: '#fff',
    maxHeight: '34px',
    height: 'auto',
    width: 'auto',
    margin: '0 auto',
    cursor: 'pointer'}} src={option.documentpath} />    </div>
          <span>
            {option.name}
          </span>
          </>
        )}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" label="Retailers" placeholder="Retailers" />
        )}
        label="Key Retailers"
        placeholder="Key Retailers"
        input="Retailer"
        control={control}
        register={register}
        // errMessage={'Please Select a Key Retailers'}
        // error={errors.Retailers&&!state.RetailerList[0]? errors.Retailers : (errors.retailerList && !state.RetailerList[0]) ? true : false}
        handleChangeSelect={handleChangeSelect}
        opneAdd={opneAdd2}
      />
      {brandName && <AddKeyPartner aws_folderName="brandlogo" opneadd={openRetailer} closeModalPopup={closeModalPopup} brandName={brandName} handleChangeSelect={handleChangeSelect} partner_type={4} input="Retailer" countryList={state.countryList} userList={state.RetailerListUser}/>}

                 </div>           
            </div>
</div>
<div className="row">
    <div className="col-lg-12">
    <div className="form-group">            
<form>
  <textarea 
  class="qtytext buytext2" 
  id="exampleFormControlTextarea1" 
  onChange={handleChange('RetailerDesc')}
  rows="3" 
  value={state.RetailerDesc}
  aria-label="empty textarea"
  placeholder="Others Key Retailers Description">
  </textarea>
  </form> 
             </div>
    </div>
</div>
</>}


{/* {(typeId==4) && (
            <div className="col-lg-12 ">
                  <h4 >Retailer Profiles *'</h4>
            <div className="form-group">        
            <SingleAutocompleteGrouping
              id="relevantProfiles"
              name="relevantRetailerProfiles"
              label="Retailer Profiles * "
              multiple={false}
              Options={state.ChannelProfileOption}
              placeholder="Channel Profiles"                        
              input='relevantRetailerProfile'              
              errMessage={'Please Select Retailer Profiles'}
              error={errors.relevantRetailerProfiles }
              value={state.ChannelProfileValue}                    
              handleChangeSelect={handleChangeSelect}
              control={control}
              register={register}
              defaultValue={state.ChannelProfileValue}
              />
            
                 </div>           
            </div>

            )}

{(typeId == '2' || typeId == '3') && 
  <div className="col-lg-12 ">
                  <h4 >Retail Customer Profile *</h4>
            <input type="text" style={{position:"absolute",left:"-10000px",top:'auto',width:'1px',height:'1px',overflow:'hidden'}} id="relevantChannelProfiles" name="relevantChannelProfiles" ref={register} value={state.ChannelProfileValue.length?state.ChannelProfileValue[0].childname:''} /> 
            <div className="form-group">        
            <FormAutocompleteGrouping
              id="relevantProfiles"
              name="relevantProfiles"
              label="Channel Profiles * "
              multiple={true}
              Options={state.ChannelProfileOption}
              placeholder="Channel Profiles"                        
              input='relevantChannelProfile'              
              errMessage={'Please Select Channel Profile'}
              error={!errors.relevantChannelProfiles || state.ChannelProfileValue.length ?false:true}
              value={state.ChannelProfileValue}                            

              optionName='ChannelProfileOption'
              optionValue='ChannelProfileValue'
              defaultValue={state.ChannelProfileValue}
              selectedItem={selectedItem}

              handleChangeSelect={handleChangeSelect}
              control={control}
              register={register}
              //defaultValue={state.ChannelProfileValue}
              />
            
                 </div>           
            </div>
}
            { typeId=='3' && <div className="col-lg-12 ">
                  <h4 >List of Services</h4>
            <div className="form-group">        
            <FormAutocomplete
              id="ListofServices"
              name="ListofServices"
              label="List of Services"
              multiple={true}
              options={state.listOfServicesOption}
              placeholder="List of Services"                        
              input='listOfServiceValue'              
              errMessage={'Please Select List of Services'}
              error={errors.ListOfServices }
              value={state.listOfServiceValue}                    
              handleChangeSelect={handleChangeSelect}
              control={control}
              register={register}
              // defaultValue={state.listOfServiceValue}
              />
            
                 </div>           
            </div>} */}
            </CardBody>
            </Card>
        
            <Card>
                <CardHeader>
                <input type="text" style={{position:"absolute",left:"-10000px",top:'auto',width:'1px',height:'1px',overflow:'hidden'}} id="typeId" ref={register} name="typeId" value={typeId} control={control} /><input type="text" style={{position:"absolute",left:"-10000px",top:'auto',width:'1px',height:'1px',overflow:'hidden'}} id="locationType" ref={register} name="locationType" value={state.title} control={control} />
                <input type="text" style={{position:"absolute",left:"-10000px",top:'auto',width:'1px',height:'1px',overflow:'hidden'}} id="selling" name="selling" ref={register} value={state.sellingCountries.length?state.sellingCountries[0].childname:''} control={control} /> 
                <div className="text-center mt-4">
                    {(typeId==3 || typeId==2) && (<input type="button" onClick={handleChange('locationType')} className={state.locationType=='Target Locations' ? "btn btn-secondary text-center btn-lg-sm-md  active" : "btn btn-secondary text-center btn-lg-sm-md" } value="Target Locations" />)}
                    {(typeId==4 || typeId==3) && (<input type="button" onClick={handleChange('locationType')} className={state.locationType=='Selling Locations' ? "btn btn-secondary text-center btn-lg-sm-md  active" : "btn btn-secondary text-center btn-lg-sm-md" } value="Selling Locations" />)}
                </div>
                {state.locationType === 'Target Locations' && <><h3 className="text-center mt-4">Select the countries where you wish to expand your business, starting with Zone, then Region. The country list will be populated from the selected region.</h3>
                <a href="#"><p className="text-center">Download list to view zones, regions and related countries</p></a></>}

                {state.locationType==='Selling Locations' && <><h3 className="text-center mt-4">Select the countries where you are currently have a presence, starting with Zone, then Region. The country list will be populated from the selected regions.</h3>
                <a href="#"><p className="text-center">Download list to view zones, regions and related countries</p></a></>}

                </CardHeader>
                <CardBody>
                    <Row>
                        <Col lg="12">
                        <h4>Choose {state.title} Zones</h4>
                        <Row>
                               <Col lg="2">
                               <div className="chck">
                                    <FormCheckBox
                                        id="EMEA"
                                        type="checkbox"
                                        checked={state.title=='TARGET' ? state.EMEA : state.EMEA1}
                                        //label=""
                                        //label1={{textAlign:"justify"}}
                                        //register={register}
                                        value='EMEA'
                                        onClick={state.title=='TARGET' ? handleChange('EMEA') : handleChange('EMEA1')}
                                    />
                                    <Badge style={{backgroundColor: "#2c9db7",color: "white",fontSize: "0.9000rem",position: "absolute",top: "5px",left: "45px"}}>
                                    EMEA
                                    </Badge>
                        
                                </div>
                               </Col>

                               {(typeId==2 || state.locationType==='Selling Locations') && 
                               <Col lg="2">
                               <div className="chck">
                                    <FormCheckBox
                                        id="APAC"
                                        type="checkbox"
                                        label="T/T "
                                        label1={{textAlign:"justify"}}
                                        //register={register}
                                        checked={state.title=='TARGET' ? state.APAC : state.APAC1}
                                        value='APAC'
                                        onClick={state.title=='TARGET' ? handleChange('APAC') : handleChange('APAC1')}
                                    />
                                    <Badge style={{backgroundColor: "#2c9db7",color: "white",fontSize: "0.9000rem",position: "absolute",top: "5px",left: "45px"}}>
                                    APAC
                                    </Badge>
                                </div>
                               </Col>
                               }
                               {state.locationType==='Selling Locations' && <Col lg="2">
                               <div className="chck">
                                    <FormCheckBox
                                        id="L/A"
                                        type="checkbox"
                                        //label=""
                                        //label1={{textAlign:"justify"}}
                                        //register={register}
                                        checked={state.title=='TARGET' ? state.AMERICAS : state.AMERICAS1}
                                        value="AMERICAS"
                                        onClick={state.title=='TARGET' ? handleChange('AMERICAS') : handleChange('AMERICAS1')}
                                    />
                                    <Badge style={{backgroundColor: "#2c9db7",color: "white",fontSize: "0.9000rem",position: "absolute",top: "5px",left: "45px"}}>
                                    AMERICAS
                                    </Badge>
                        
                                </div>
                               </Col>}
                               </Row>
                                {/* <div className="text-center mt-4">
                                 <button type="submit" className="btn btn-primary" >Save</button> 
                                </div> */}
                        </Col>
                    </Row>
                    {state.locationType === 'Target Locations' ?
                     <Row>
                        <Col lg="12" className="mt-4">
                            <h4>Choose {state.title} Regions</h4>
                        <div className="form-group">               
                        <input type="text" style={{position:"absolute",left:"-10000px",top:'auto',width:'1px',height:'1px',overflow:'hidden'}} id="target" name="target" ref={register} value={state.targetCountries.length?state.targetCountries[0].childname:''} control={control} /> 
                        <FormAutocompleteGroupingRegion
                            input="targetCountries"
                            id="Countries"
                            label="Countries"
                            name="Countries"
                            Options={state.targetCountriesOption}
                            placeholder="Search"              
                            errMessage={'Please choose your Countries'}
                            error={!errors.target || state.targetCountries.length ?false:true}
                            optionName='targetCountriesOption'
                            optionValue='targetCountries'
                            defaultValue={state.targetCountries}
                            value={state.targetCountries}         
                            loading={true}
                            selectedItem={selectedItem}
                            handleChangeSelect={handleChangeSelect}
                            control={control}
                            register={register}
                             />
                        </div>
                        </Col>
                    </Row>
                    :
                    <Row>
                        <Col lg="12" className="mt-4">
                        <h4>Choose {state.title} Countries</h4>
                        <div className="form-group">               
                        
                        <FormAutocompleteGroupingRegion
                            input="sellingCountries"
                            id="Countries"
                            label="Countries"
                            name="Countries"
                            Options={state.sellingCountriesOption}
                            placeholder="Search"              
                            errMessage={'Please choose your Countries'}
                            error={!errors.selling || state.sellingCountries.length ?false:true}
                            optionName='sellingCountriesOption'
                            optionValue='sellingCountries'
                            defaultValue={state.sellingCountries}
                            value={state.sellingCountries}         
                            loading={true}
                            selectedItem={selectedItem}
                            handleChangeSelect={handleChangeSelect}
                            control={control}
                            register={register}
                             />
                        </div>
                        </Col>
                    </Row>
                    }

                  {/* { state.locationType === 'Selling Locations' && <><Row>
                        <Col lg="12">
                        <h4>1 - Choose Selling Zones</h4>
                        <Row>
                               <Col lg="2">
                               <div className="chck">
                                    <FormCheckBox
                                        id="L/C"
                                        type="checkbox"
                                        //label=""
                                        //label1={{textAlign:"justify"}}
                                        //register={register}
                                    />
                                    <Badge style={{backgroundColor: "#2c9db7",color: "white",fontSize: "0.9000rem",position: "absolute",top: "5px",left: "45px"}}>
                                    EMEA
                                    </Badge>
                        
                                </div>
                               </Col>
                               <Col lg="2">
                               <div className="chck">
                                    <FormCheckBox
                                        id="T/T "
                                        type="checkbox"
                                        label="T/T "
                                        label1={{textAlign:"justify"}}
                                        //register={register}
                                    />
                                    <Badge style={{backgroundColor: "#2c9db7",color: "white",fontSize: "0.9000rem",position: "absolute",top: "5px",left: "45px"}}>
                                    APAC
                                    </Badge>
                                </div>
                               </Col>
                               <Col lg="2">
                               <div className="chck">
                                    <FormCheckBox
                                        id="D/D"
                                        type="checkbox"
                                        label="D/D"
                                        label1={{textAlign:"justify"}}
                                        //register={register}
                                    />
                                    <Badge style={{backgroundColor: "#2c9db7",color: "white",fontSize: "0.9000rem",position: "absolute",top: "5px",left: "45px"}}>
                                    AMERICAS
                                    </Badge>
                                </div>
                               </Col>
                               </Row>
                                <div className="text-center mt-4">
                                 <button type="submit" className="btn btn-primary" >Save</button> 
                                </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12">
                            <h4 className="mt-4">2 - Choose Selling Regions</h4>
                        <div className="form-group">               
                        <input type="text" style={{position:"absolute",left:"-10000px",top:'auto',width:'1px',height:'1px',overflow:'hidden'}} id="target" name="target" ref={register} value={state.targetCountries.length?state.targetCountries[0].childname:''} /> 
                        <FormAutocompleteGrouping
                            input="Countries"
                            id="Countries"
                            label="Countries"
                            name="Countries"
                            Options={state.targetCountriesOption}
                            placeholder="Search"              
                            errMessage={'Please choose your Countries'}
                            error={!errors.target || state.targetCountries.length ?false:true}
                            optionName='targetCountriesOption'
                            optionValue='targetCountries'
                            defaultValue={state.targetCountries}
                            value={state.targetCountries}         
                            loading={true}
                            selectedItem={selectedItem}
                            handleChangeSelect={handleChangeSelect}
                            control={control}
                            register={register}
                             />
                        </div>
                        </Col>
                    </Row>
                    
                    <Row>
                        <Col lg="12">
                        <h4>3 - Choose Selling Countries</h4>
                        <div className="form-group">               
                        <input type="text" style={{position:"absolute",left:"-10000px",top:'auto',width:'1px',height:'1px',overflow:'hidden'}} id="target" name="target" ref={register} value={state.targetCountries.length?state.targetCountries[0].childname:''} /> 
                        <FormAutocompleteGrouping
                            input="Countries"
                            id="Countries"
                            label="Countries"
                            name="Countries"
                            Options={state.targetCountriesOption}
                            placeholder="Search"              
                            errMessage={'Please choose your Countries'}
                            error={!errors.target || state.targetCountries.length ?false:true}
                            optionName='targetCountriesOption'
                            optionValue='targetCountries'
                            defaultValue={state.targetCountries}
                            value={state.targetCountries}         
                            loading={true}
                            selectedItem={selectedItem}
                            handleChangeSelect={handleChangeSelect}
                            control={control}
                            register={register}
                             />
                        </div>
                        </Col>
                    </Row></> */}

                </CardBody>
            </Card>

        <div className="text-center">
        <button type="submit" className="btn btn-primary" >Save</button> 
          </div> 
          </form>
          
              </Container>
)}
      </div>
    
   
  );
};

const top100Films = [
  { name: 'The Shawshank Redemption', id: 1994 },
  { name: 'The Godfather', id: 1972 },
  { name: 'The Godfather: Part II', id: 1974 },
  { name: 'The Dark Knight', id: 2008 },
  { name: 'The Shawshank Redemption', id: 1994 },
  { name: 'The Godfather', id: 1972 },
  { name: 'The Godfather: Part II', id: 1974 },
  { name: 'The Dark Knight', id: 2008 },
  { name: 'The Shawshank Redemption', id: 1994 },
  { name: 'The Godfather', id: 1972 },
  { name: 'The Godfather: Part II', id: 1974 },
  { name: 'The Dark Knight', id: 2008 },
]

const startUp = [
  {label : 'Prototype', id: 1, value: 'PROTOTYPE'},
  {label : 'Shipping to first backers', id: 2, value: 'S_BACKER'},
  {label : 'Shipping in volume', id: 3, value: 'S_VOLUME'},
];


const radioGroupOptions = [
  {
    value: "1",
    label: "Yes",
  },
  {
    value: "0",
    label: "No",
  },
 
];

export default TradeInformation;
